/* Simple Pledge Warenkorb-Drawer (10.10.2026) – ersetzt UpCart.
   Konfiguration: Theme-Einstellungen → "Simple Pledge Warenkorb" (JSON in #SpCartConfig).
   Fängt alle Add-to-Cart-Wege ab: Produktformulare, fetch/XHR auf /cart/add, Theme-Events, Warenkorb-Symbol. */
(function () {
  'use strict';
  if (window.__spCartLoaded) return; window.__spCartLoaded = true;   // Achtung: window.SpCart wäre das DOM-Element #SpCart
  var root = document.getElementById('SpCart');
  var cfgEl = document.getElementById('SpCartConfig');
  if (!root || !cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  document.documentElement.setAttribute('data-spc', '1');

  var $ = function (sel) { return root.querySelector(sel); };
  var panel = $('.spc-panel');
  var els = {
    count: $('[data-spc-count]'), rewards: $('[data-spc-rewards]'), lines: $('[data-spc-lines]'), extras: $('[data-spc-extras]'),
    empty: $('[data-spc-empty]'), foot: $('[data-spc-foot]'), msg: $('[data-spc-msg]'), total: $('[data-spc-total]'), orig: $('[data-spc-orig]'),
    discounts: $('[data-spc-discounts]'), shipnote: $('[data-spc-shipnote]'), codewrap: $('[data-spc-codewrap]'),
    codeToggle: $('[data-spc-code-toggle]'), codeForm: $('[data-spc-code-form]')
  };
  var state = { cart: null, open: false, busy: false, lastFocus: null, giftBusy: false };
  var isCartPage = /\/cart\/?$/.test(location.pathname);

  /* ---------- Helpers ---------- */
  var fmt = function (c) { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: cfg.currency || 'EUR' }); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };
  var ss = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };
  var untilOk = function (iso) { if (!iso) return true; var d = new Date(iso + 'T23:59:59+01:00'); return isNaN(d) || Date.now() <= d.getTime(); };
  /* 22.10.2026: Angebotswechsel per Datum (Theme-Einstellungen „Gültig ab“ + „Vorheriges Angebot“).
     Vor dem Starttag gilt das vorherige Angebot (AKTION2026/TRIO2026 bis 26.10.), ab 00:00 deutscher Zeit das neue (DUO bis 16.11.).
     Die Entscheidung fällt im Browser – auch eine vor Mitternacht zwischengespeicherte Seite wechselt pünktlich. */
  /* 22.10.2026 abends: Duo-Angebot nur noch auf den Landingpages. Ohne „shopweit“ setzt der Warenkorb DUO NICHT selbst,
     sondern rechnet nur, wenn der Code schon drin ist (Duo-LP oder Link /discount/DUO). Gilt für alle Typen aus duoTypes. */
  var duoTypes = (cfg.duoTypes && cfg.duoTypes.length ? cfg.duoTypes : [cfg.duoType]).map(function (t) { return String(t || '').trim(); }).filter(Boolean);
  function isDuoItem(i) { return !isGift(i) && duoTypes.indexOf(String(i.product_type || '').trim()) > -1; }
  function duoUnits(cart) { return cart.items.filter(isDuoItem).reduce(function (a, i) { return a + i.quantity; }, 0); }
  function hasCode(cart, code) { code = String(code || '').toUpperCase(); return !!code && (cart.discount_codes || []).some(function (c) { return String(c.code).toUpperCase() === code; }); }
  var oldCodes = [cfg.duoPrevCode, cfg.duoPrevTrio].filter(Boolean).map(function (c) { return String(c).toUpperCase(); });
  (function () {
    if (!cfg.duoFrom) return;
    var start = new Date(cfg.duoFrom + 'T00:00:00+01:00').getTime();
    if (isNaN(start) || Date.now() >= start) return;
    cfg.duoCode = cfg.duoPrevCode || ''; cfg.trioCode = cfg.duoPrevTrio || ''; cfg.duoUntil = cfg.duoPrevUntil || '';
  })();
  var origFetch = window.fetch.bind(window);
  function api(url, body) {
    var opt = { credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-SPC': '1' } };
    if (body !== undefined) { opt.method = 'POST'; opt.body = JSON.stringify(body); }
    return origFetch(url, opt).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || 'Fehler'); err.data = j; throw err; } return j; });
    });
  }
  var getCart = function () { return api('/cart.js'); };
  function emitUpdated(cart) { try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'sp-cart' } })); } catch (e) {} }
  function showMsg(text, ok) {
    if (!text) { els.msg.hidden = true; return; }
    els.msg.textContent = text; els.msg.classList.toggle('is-ok', !!ok); els.msg.hidden = false;
    clearTimeout(showMsg.t); showMsg.t = setTimeout(function () { els.msg.hidden = true; }, 5000);
  }
  function isGift(i) { return cfg.giftVariant && i.variant_id === cfg.giftVariant; }
  /* Gratis-Armreif (automatischer BXGY) und AKTION2026 (BXGY-Code) schließen sich in Shopify aus –
     liegt der Duo-Code im Warenkorb, gewinnt er (das verspricht die Duo-Seite), der Armreif wird nicht dazugelegt. */
  function duoCodeIn(cart) {
    if (aktionCodeIn(cart)) return true;
    if (!hasCode(cart, cfg.duoCode)) return false;
    // nur blockieren, wenn der Duo-Code auch greifen kann (mind. 2 Duo-Teile) – sonst bekommt die Kundin den Armreif
    return duoUnits(cart) >= 2;
  }
  /* Aktion „Jedes 2. Teil gratis“ (BXGY-Code, z. B. ZWEITESGRATIS): ab 2 Teilen gewinnt der Code, kein Gratis-Armreif. */
  function aktionCodeIn(cart) {
    var a = (cfg.aktionCode || '').toUpperCase();
    if (!a || !(cart.discount_codes || []).some(function (c) { return c.code.toUpperCase() === a; })) return false;
    var units = cart.items.filter(function (i) { return !isGift(i) && !isWrap(i); }).reduce(function (n, i) { return n + i.quantity; }, 0);
    return units >= 2;
  }
  function isWrap(i) { return cfg.wrapVariant && i.variant_id === cfg.wrapVariant; }
  function baseSubtotal(cart) { return cart.items.reduce(function (a, i) { return a + (isGift(i) ? 0 : i.original_line_price); }, 0); }
  function unitCount(cart) { return cart.items.reduce(function (a, i) { return a + (isGift(i) ? 0 : i.quantity); }, 0); }

  /* ---------- Lieferdatum (Werktage Mo–Fr) ---------- */
  function addBusinessDays(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function deliveryText() {
    var now = new Date(), f = { weekday: 'short', day: '2-digit', month: '2-digit' };
    var a = addBusinessDays(now, cfg.deliveryMin || 1), b = addBusinessDays(now, cfg.deliveryMax || 3);
    return 'Lieferung voraussichtlich ' + a.toLocaleDateString('de-DE', f) + ' – ' + b.toLocaleDateString('de-DE', f);
  }

  /* ---------- Render ---------- */
  function rewardsHTML(cart) {
    var base = baseSubtotal(cart), units = unitCount(cart), shipBase = cart.total_price;   // Versand: Betrag NACH Rabatt (Shopify-Versandstufe), Geschenk: Warenwert vor Rabatt
    var ship = cfg.shipThreshold || 0, gift = cfg.giftVariant && !duoCodeIn(cart) ? (cfg.giftThreshold || 0) : 0;
    var shipBy2 = cfg.shipFrom2 && untilOk(cfg.shipFrom2Until) && units >= 2;
    var shipDone = shipBase >= ship || shipBy2;
    var hasGift = cart.items.some(isGift);
    var giftDone = gift > 0 && (base >= gift || hasGift);
    var max = gift || ship; if (!max) return '';
    var pct = Math.min(100, Math.round((shipDone ? base : shipBase) / max * 100));
    if (shipDone && ship && !gift) pct = 100;
    var msg;
    if (!shipDone && ship) msg = 'Noch <strong>' + fmt(ship - shipBase) + '</strong> bis ' + esc(cfg.shipLabel).toLowerCase() + (cfg.shipFrom2 && untilOk(cfg.shipFrom2Until) ? ' – oder einfach ein 2. Teil dazu' : '');
    else if (gift && !giftDone) msg = (ship ? '✓ ' + esc(cfg.shipLabel) + ' · ' : '') + 'noch <strong>' + fmt(gift - base) + '</strong> bis zum ' + esc(cfg.giftLabel) + (cfg.giftValue ? ' (Wert ' + esc(cfg.giftValue) + ')' : '');
    else msg = '🎉 Freigeschaltet: ' + (ship ? esc(cfg.shipLabel) : '') + (gift ? (ship ? ' + ' : '') + esc(cfg.giftLabel) + (cfg.giftValue ? ' (Wert ' + esc(cfg.giftValue) + ')' : '') : '');
    var tick = '<svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>';
    var ms = '', labels = '';
    if (ship && gift) {
      var sp = Math.min(96, Math.round(ship / max * 100));
      ms += '<span class="spc-rw-ms' + (shipDone ? ' is-done' : '') + '" style="left:' + sp + '%">' + tick + '</span>';
      labels += '<span class="' + (shipDone ? 'is-done' : '') + '" style="left:' + sp + '%">Versand frei</span>';
    }
    ms += '<span class="spc-rw-ms' + ((gift ? giftDone : shipDone) ? ' is-done' : '') + '" style="left:100%">' + (gift ? '<svg viewBox="0 0 24 24"><rect x="3" y="8" width="18" height="13" rx="1"/><path d="M12 8v13M3 12h18"/></svg>' : tick) + '</span>';
    labels += '<span class="' + ((gift ? giftDone : shipDone) ? 'is-done' : '') + '" style="left:100%">' + (gift ? 'Gratis-Geschenk' : 'Versand frei') + '</span>';
    var fill = shipBy2 && !gift ? 100 : pct;
    var giftBtn = '';
    if (gift && base >= gift && !hasGift && cfg.giftVariant) giftBtn = '<div class="spc-rw-gift">🎁 ' + esc(cfg.giftLabel) + ' ist freigeschaltet <button type="button" data-spc-gift-add>Hinzufügen</button></div>';
    return '<p class="spc-rw-msg">' + msg + '</p><div class="spc-rw-bar"><span class="spc-rw-fill" style="width:' + fill + '%"></span>' + ms + '</div><div class="spc-rw-labels">' + labels + '</div>' + giftBtn;
  }

  function lineHTML(i) {
    var gift = isGift(i);
    var img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
    var variant = i.variant_title && i.variant_title !== 'Default Title' ? '<div class="spc-line-v">' + esc(i.variant_title) + '</div>' : '';
    var props = '', pr = i.properties || {};
    var engr = pr['Individuelle Gravur'] || pr['Gravur'] || '';
    if (engr) {
      props += '<div class="spc-line-engr">Gravur: <q>' + esc(engr) + '</q></div>' +
        '<button type="button" class="spc-edit" data-spc-edit>Gravur bearbeiten</button>' +
        '<form class="spc-editor" data-spc-editor hidden><input type="text" autocomplete="off" aria-label="Gravurtext" value="' + esc(engr) + '">' +
        '<div class="spc-editor-row"><small data-spc-edit-count></small><span><button type="button" class="spc-editor-cancel" data-spc-edit-cancel>Abbrechen</button><button type="submit" class="spc-editor-save">Speichern</button></span></div>' +
        '<small class="spc-editor-err" data-spc-edit-err hidden></small></form>';
    }
    if (pr.Latitude && pr.Longitude) props += '<div class="spc-line-v">Koordinaten: ' + esc(pr.Latitude) + ', ' + esc(pr.Longitude) + '</div>';
    Object.keys(pr).forEach(function (k) {
      if (k.charAt(0) === '_' || !pr[k] || /^(Individuelle Gravur|Gravur|Latitude|Longitude|Configurator)$/.test(k)) return;
      props += '<div class="spc-line-v">' + esc(k === 'Gravurtyp' ? 'Gravur-Stil' : k) + ': ' + esc(pr[k]) + '</div>';
    });
    var discs = (i.line_level_discount_allocations || []).filter(function (d) { return d.amount > 0; }).map(function (d) {
      return '<div class="spc-line-d"><svg viewBox="0 0 24 24"><path d="M20 12 12 20l-9-9V4h7z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg>' + esc(d.discount_application.title) + '</div>';
    }).join('');
    var price = (i.original_line_price > i.final_line_price ? '<s>' + fmt(i.original_line_price) + '</s>' : '') + '<strong>' + (i.final_line_price === 0 ? 'Gratis' : fmt(i.final_line_price)) + '</strong>';
    var qty = gift ? '<span class="spc-line-gift">Geschenk</span>' :
      '<div class="spc-qty"><button type="button" data-spc-qty="-1" aria-label="Weniger">−</button><span>' + i.quantity + '</span><button type="button" data-spc-qty="1" aria-label="Mehr">+</button></div>';
    return '<li class="spc-line" data-key="' + esc(i.key) + '" data-qty="' + i.quantity + '"' + (gift ? ' data-gift="1"' : '') + '>' +
      '<a href="' + esc(i.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="76" height="76" loading="eager">' : '') + '</a>' +
      '<div><a class="spc-line-t" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + variant + props + discs + qty + '</div>' +
      '<div class="spc-line-r"><div class="spc-line-p">' + price + '</div><button type="button" class="spc-rm" data-spc-rm>Entfernen</button></div></li>';
  }

  function duoCandidate(cart) {
    if (!cfg.duoEnable || !cfg.duoCode || !untilOk(cfg.duoUntil)) return null;
    if (!cfg.duoShopwide && !hasCode(cart, cfg.duoCode)) return null;   // Hinweis nur, wenn DUO schon im Warenkorb liegt
    if (cfg.duoShopwide && cfg.duoOnlyCampaign && ss.get('sp_duo') !== '1') return null;
    var duo = cfg.duoShopwide ? cart.items.filter(function (i) { return !isGift(i) && (i.product_type || '') === cfg.duoType; }) : cart.items.filter(isDuoItem);
    var units = duo.reduce(function (a, i) { return a + i.quantity; }, 0);
    return units === 1 ? duo[0] : null;
  }

  function extrasHTML(cart) {
    var html = '';
    var d = duoCandidate(cart);
    if (d) {
      var half = Math.round(d.price / 2);
      html += '<div class="spc-card spc-card--duo">' + (d.image ? '<img src="' + esc(d.image) + '" alt="">' : '') +
        '<div class="spc-card-b"><div class="spc-card-t">Eins für sie, eins für dich – das 2. zum halben Preis</div><div class="spc-card-s">' + esc(d.product_title) + (d.variant_title ? ' · ' + esc(d.variant_title) : '') + ' für nur ' + fmt(half) + ' statt ' + fmt(d.price) + ' · Rabatt automatisch' + (cfg.duoUntil ? ' · nur bis ' + cfg.duoUntil.slice(8, 10) + '.' + cfg.duoUntil.slice(5, 7) + '.' : '') + '</div></div>' +
        '<button type="button" class="spc-add" data-spc-duo="' + d.variant_id + '">+ Hinzufügen</button></div>';
    }
    if (cfg.wrapVariant) {
      var on = cart.items.some(isWrap);
      html += '<label class="spc-card">' + (cfg.wrapImage ? '<img src="' + esc(cfg.wrapImage) + '" alt="">' : '') +
        '<span class="spc-card-b"><span class="spc-card-t">' + esc(cfg.wrapLabel) + '</span><span class="spc-card-s" style="display:block">Luxuriöse Box mit Satinschleife · +' + fmt(cfg.wrapPrice) + '</span></span>' +
        '<span class="spc-switch"><input type="checkbox" data-spc-wrap' + (on ? ' checked' : '') + ' aria-label="' + esc(cfg.wrapLabel) + '"><span></span></span></label>';
    }
    return html;
  }

  function discountsHTML(cart) {
    var map = {};
    (cart.cart_level_discount_applications || []).forEach(function (d) { map[d.title] = (map[d.title] || 0) + d.total_allocated_amount; });
    cart.items.forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application.title; map[t] = (map[t] || 0) + a.amount; }); });
    var codes = (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code.toUpperCase(); });
    return Object.keys(map).filter(function (t) { return map[t] > 0; }).map(function (t) {
      var isCode = codes.indexOf(String(t).toUpperCase()) > -1;
      return '<div class="spc-disc"><span>' + esc(t) + (isCode ? '<button type="button" data-spc-code-rm="' + esc(t) + '">entfernen</button>' : '') + '</span><span>−' + fmt(map[t]) + '</span></div>';
    }).join('');
  }

  function render(cart) {
    state.cart = cart;
    var visible = cart.items.filter(function (i) { return !isWrap(i); });
    var count = cart.item_count;
    els.count.textContent = count ? '(' + count + ')' : '';
    var empty = cart.item_count === 0;
    els.empty.hidden = !empty; els.foot.hidden = empty; els.rewards.hidden = empty;
    els.lines.innerHTML = visible.map(lineHTML).join('');
    els.extras.innerHTML = empty ? '' : extrasHTML(cart);
    if (!empty) {
      els.rewards.innerHTML = rewardsHTML(cart);
      els.rewards.hidden = !els.rewards.innerHTML;
      els.discounts.innerHTML = discountsHTML(cart);
      els.total.textContent = fmt(cart.total_price);
      if (cart.original_total_price > cart.total_price) { els.orig.textContent = fmt(cart.original_total_price); els.orig.hidden = false; } else els.orig.hidden = true;
      var base = baseSubtotal(cart), units = unitCount(cart);
      var shipFree = cart.total_price >= (cfg.shipThreshold || 0) || (cfg.shipFrom2 && untilOk(cfg.shipFrom2Until) && units >= 2);
      var custom = cart.items.some(function (i) { return (i.product_type || '') === 'Personalized'; });
      els.shipnote.textContent = (shipFree ? 'Versand: kostenlos · ' : 'zzgl. Versand · ') + (custom ? 'Wunschgravur wird individuell für dich angefertigt – Lieferzeit siehe Produktseite' : deliveryText());
      els.codewrap.hidden = !cfg.codeField;
      var t2 = root.querySelector('[data-spc-trust2]'); if (t2) t2.hidden = custom;   // "Versand in 24 h" nicht bei Wunschgravur
    }
  }

  /* ---------- Geschenk-Automatik ---------- */
  function syncGift(cart) {
    if (!cfg.giftAuto || !cfg.giftVariant || state.giftBusy) return Promise.resolve(cart);
    var base = baseSubtotal(cart);
    var gifts = cart.items.filter(isGift);
    var eligible = base >= (cfg.giftThreshold || Infinity) && !duoCodeIn(cart);
    var declined = ss.get('spc_gift_declined') === '1';
    var notFreeAt = parseInt(ss.get('spc_gift_notfree') || '0', 10);
    var job = null;
    if (!eligible && gifts.length) job = api('/cart/update.js', { updates: (function () { var u = {}; u[cfg.giftVariant] = 0; return u; })() });
    else if (eligible && gifts.length) {
      var g = gifts[0];
      if (g.final_line_price > 0) { ss.set('spc_gift_notfree', String(base)); job = api('/cart/change.js', { id: g.key, quantity: 0 }); }
      else if (gifts.length > 1 || g.quantity > 1) job = api('/cart/change.js', { id: g.key, quantity: 1 });
    } else if (eligible && !gifts.length && !declined && notFreeAt !== base) job = api('/cart/add.js', { items: [{ id: cfg.giftVariant, quantity: 1 }] });
    if (!job) return Promise.resolve(cart);
    state.giftBusy = true;
    return job.then(getCart).then(function (c) {
      var g = c.items.filter(isGift)[0];
      if (g && g.final_line_price > 0) { ss.set('spc_gift_notfree', String(baseSubtotal(c))); return api('/cart/change.js', { id: g.key, quantity: 0 }).then(getCart); }
      return c;
    }).catch(function () { return getCart(); }).then(function (c) { state.giftBusy = false; return c; });
  }

  /* ---------- Duo-Rabatt automatisch ---------- */
  function syncDuo(cart) {
    if (!cfg.duoShopwide) return Promise.resolve(cart);   // nur Landingpage/Link setzen den Code
    if (!cfg.duoEnable || !cfg.duoCode || !untilOk(cfg.duoUntil)) return Promise.resolve(cart);
    if (cfg.duoOnlyCampaign && ss.get('sp_duo') !== '1') return Promise.resolve(cart);
    var units = cart.items.filter(function (i) { return !isGift(i) && (i.product_type || '') === cfg.duoType; }).reduce(function (a, i) { return a + i.quantity; }, 0);
    var codes = (cart.discount_codes || []).map(function (c) { return c.code.toUpperCase(); });
    var duo = cfg.duoCode.toUpperCase(), trio = (cfg.trioCode || '').toUpperCase();
    // eigene Codes = aktuelle + vorherige (z. B. abgelaufenes AKTION2026 im Warenkorb wird ab 27.10. gegen DUO getauscht)
    var onlyOurs = codes.every(function (c) { return c === duo || c === trio || oldCodes.indexOf(c) > -1; });
    var want = null;
    if (units === 2) want = cfg.duoCode;
    else if (units >= 3) want = cfg.trioCode || cfg.duoCode;   // ohne Trio-Code gilt der Duo-Code auch ab 3 Teilen
    // nur eigene Aktionscodes tauschen – fremde Codes der Kundin nie überschreiben
    if (want && onlyOurs && !(codes.length === 1 && codes[0] === want.toUpperCase()))
      return api('/cart/update.js', { discount: want }).then(getCart).catch(function () { return cart; });
    return Promise.resolve(cart);
  }

  function refresh() {
    return getCart().then(syncReplace).then(syncDuo).then(syncGift).then(function (c) { render(c); emitUpdated(c); return c; }).catch(function () {});
  }

  /* ---------- Öffnen / Schließen ---------- */
  function open() {
    if (isCartPage) return;
    if (!state.open) {
      state.lastFocus = document.activeElement;
      root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.body.classList.add('spc-lock');
      state.open = true;
      setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
    }
    return refresh();
  }
  function close() {
    if (!state.open) return;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.body.classList.remove('spc-lock');
    state.open = false;
    if (state.lastFocus && state.lastFocus.focus) try { state.lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ---------- Gravur bearbeiten (personalisierte Produkte) ---------- */
  var ENGRAVE_OK = /^[A-Za-z0-9ÄÖÜäöü+#;:().‘'&@\/?!%={}[\]<>$|*+:" _\\°'.\-]+$/;   // wie im Konfigurator
  var maxCache = {};
  function lineByKey(key) { return (state.cart.items || []).filter(function (i) { return i.key === key; })[0]; }
  function hasSymbols(pr) { return !!(pr._CUSTOM_ENGRAVING && pr['Individuelle Gravur'] && pr._CUSTOM_ENGRAVING !== pr['Individuelle Gravur']); }
  function maxLen(item) {
    if (maxCache[item.handle]) return Promise.resolve(maxCache[item.handle]);
    return origFetch(item.url.split('?')[0], { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
      var m = h.match(/data-max-length="(\d+)"/); maxCache[item.handle] = m ? parseInt(m[1], 10) : 40; return maxCache[item.handle];
    }).catch(function () { return 40; });
  }
  function openEditor(line) {
    var item = lineByKey(line.dataset.key); if (!item) return;
    var pr = item.properties || {};
    if (hasSymbols(pr)) {   // Gravur mit Symbolen → im Konfigurator neu gestalten, alter Artikel wird danach ersetzt
      ss.set('spc_replace', JSON.stringify({ key: item.key, pid: item.product_id }));
      location.href = item.url;
      return;
    }
    var form = line.querySelector('[data-spc-editor]'), input = form.querySelector('input'), count = form.querySelector('[data-spc-edit-count]');
    line.querySelector('[data-spc-edit]').hidden = true; form.hidden = false; input.focus(); input.select();
    maxLen(item).then(function (mx) {
      input.maxLength = mx;
      var upd = function () { count.textContent = input.value.length + '/' + mx; };
      input.oninput = upd; upd();
    });
    form.onsubmit = function (e) {
      e.preventDefault();
      var val = input.value.trim(), err = form.querySelector('[data-spc-edit-err]');
      if (!val) { err.textContent = 'Bitte gib einen Gravurtext ein.'; err.hidden = false; return; }
      if (!ENGRAVE_OK.test(val)) { err.textContent = 'Dieses Zeichen kann leider nicht graviert werden.'; err.hidden = false; return; }
      if (input.maxLength > 0 && val.length > input.maxLength) { err.textContent = 'Maximal ' + input.maxLength + ' Zeichen.'; err.hidden = false; return; }
      var up = val.toUpperCase(), props = {};
      Object.keys(pr).forEach(function (k) { props[k] = pr[k]; });
      props['Individuelle Gravur'] = up; props._AJAX_Individuellle_Gravur = up; props._CUSTOM_ENGRAVING = up; props._symbols_url = val; props._UNIQUE_ID = String(Date.now());
      withBusy(line, api('/cart/change.js', { id: item.key, quantity: item.quantity, properties: props })
        .then(function () { showMsg('Gravur aktualisiert: „' + up + '“', true); }));
    };
  }
  function syncReplace(cart) {
    var r = ss.get('spc_replace'); if (!r) return Promise.resolve(cart);
    try { r = JSON.parse(r); } catch (e) { ss.del('spc_replace'); return Promise.resolve(cart); }
    var old = cart.items.filter(function (i) { return i.key === r.key; })[0];
    if (!old) { ss.del('spc_replace'); return Promise.resolve(cart); }
    var fresh = cart.items.some(function (i) { return i.product_id === r.pid && i.key !== r.key && !isGift(i); });
    if (!fresh) return Promise.resolve(cart);
    ss.del('spc_replace');
    return api('/cart/change.js', { id: r.key, quantity: 0 }).then(getCart).then(function (c) { showMsg('Gravur geändert – der alte Artikel wurde ersetzt.', true); return c; }).catch(function () { return cart; });
  }

  /* ---------- Aktionen im Drawer ---------- */
  function withBusy(lineEl, promise) {
    if (lineEl) lineEl.classList.add('is-busy');
    return promise.then(refresh).catch(function (e) { showMsg(e.message || 'Das hat nicht geklappt – bitte erneut versuchen.'); return refresh(); });
  }
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-spc-close]')) { e.preventDefault(); close(); return; }
    var line = t.closest('.spc-line');
    if (t.closest('[data-spc-qty]') && line) {
      var q = parseInt(line.dataset.qty, 10) + parseInt(t.closest('[data-spc-qty]').dataset.spcQty, 10);
      withBusy(line, api('/cart/change.js', { id: line.dataset.key, quantity: Math.max(0, q) }));
      return;
    }
    if (t.closest('[data-spc-rm]') && line) {
      if (line.dataset.gift) ss.set('spc_gift_declined', '1');
      withBusy(line, api('/cart/change.js', { id: line.dataset.key, quantity: 0 }));
      return;
    }
    if (t.closest('[data-spc-gift-add]')) {
      ss.del('spc_gift_declined'); ss.del('spc_gift_notfree');
      withBusy(null, api('/cart/add.js', { items: [{ id: cfg.giftVariant, quantity: 1 }] }));
      return;
    }
    if (t.closest('[data-spc-edit]') && line) { openEditor(line); return; }
    if (t.closest('[data-spc-edit-cancel]') && line) { line.querySelector('[data-spc-editor]').hidden = true; line.querySelector('[data-spc-edit]').hidden = false; return; }
    var duoBtn = t.closest('[data-spc-duo]');
    if (duoBtn) {
      duoBtn.disabled = true;
      withBusy(null, api('/cart/add.js', { items: [{ id: parseInt(duoBtn.dataset.spcDuo, 10), quantity: 1 }] })
        .then(function () { return api('/cart/update.js', { discount: cfg.duoCode }); })
        .then(function () { showMsg('2. Armband zum halben Preis – Rabatt ist aktiv.', true); }));
      return;
    }
    var rmCode = t.closest('[data-spc-code-rm]');
    if (rmCode) {
      var rest = (state.cart.discount_codes || []).map(function (c) { return c.code; }).filter(function (c) { return c.toUpperCase() !== rmCode.dataset.spcCodeRm.toUpperCase(); });
      withBusy(null, api('/cart/update.js', { discount: rest.join(',') }));
      return;
    }
    if (t.closest('[data-spc-code-toggle]')) {
      var openNow = els.codeForm.hidden; els.codeForm.hidden = !openNow; els.codeToggle.setAttribute('aria-expanded', String(openNow));
      if (openNow) els.codeForm.querySelector('input').focus();
    }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-spc-wrap]')) {
      var on = e.target.checked;
      var p = on ? api('/cart/add.js', { items: [{ id: cfg.wrapVariant, quantity: 1 }] })
        : api('/cart/update.js', { updates: (function () { var u = {}; u[cfg.wrapVariant] = 0; return u; })() });
      withBusy(null, p);
    }
  });
  els.codeForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = els.codeForm.querySelector('input'); var code = input.value.trim(); if (!code) return;
    var codes = (state.cart.discount_codes || []).map(function (c) { return c.code; }).concat([code]);
    api('/cart/update.js', { discount: codes.join(',') }).then(getCart).then(function (c) {
      var hit = (c.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
      if (hit && hit.applicable) { showMsg('Code „' + code + '“ ist aktiv.', true); input.value = ''; }
      else if (hit && cfg.duoCode && code.toUpperCase() === String(cfg.duoCode).toUpperCase() && untilOk(cfg.duoUntil) && duoUnits(c) < 2) {
        // DUO greift erst ab 2 Teilen – Code behalten und erklären statt entfernen
        showMsg('Code „' + code + '“ ist gespeichert – das 2. Teil wird zum halben Preis, sobald zwei Schmuckstücke mit Gravur im Warenkorb liegen.', true); input.value = '';
      }
      else {
        showMsg('Der Code „' + code + '“ ist für diesen Warenkorb nicht gültig.');
        var keep = (c.discount_codes || []).filter(function (d) { return d.applicable && d.code.toUpperCase() !== code.toUpperCase(); }).map(function (d) { return d.code; });
        return api('/cart/update.js', { discount: keep.join(',') }).then(refresh);   // ungültigen Code nicht im Warenkorb liegen lassen
      }
      return refresh();
    }).catch(function () { showMsg('Der Code konnte nicht geprüft werden.'); });
  });
  document.addEventListener('keydown', function (e) {
    if (!state.open) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])');
      f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------- Abfangen: Warenkorb-Symbol, Formulare, Requests, Events ---------- */
  document.addEventListener('click', function (e) {
    if (isCartPage || e.defaultPrevented || e.metaKey || e.ctrlKey) return;
    var a = e.target.closest('a[href$="/cart"], a[href="/cart"], .js-drawer-open-cart, [aria-controls="CartDrawer"]');
    if (!a || root.contains(a)) return;
    e.preventDefault(); e.stopPropagation(); open();
  }, true);

  function isAddForm(form) { return form && form.matches && form.matches('form[action*="/cart/add"]') && !form.hasAttribute('data-spc-ignore') && !isCartPage; }
  function handleAddForm(form) {
    var btn = form.querySelector('[type="submit"],button[name="add"]'); if (btn) btn.setAttribute('aria-busy', 'true');
    return origFetch('/cart/add.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'X-SPC': '1', 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Nicht verfügbar'); return j; }); })
      .then(function (item) { try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } })); } catch (x) {} return open(); })
      .catch(function (err) { return open().then(function () { showMsg(err.message); }); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  document.addEventListener('submit', function (e) {
    if (!isAddForm(e.target) || e.defaultPrevented) return;
    e.preventDefault();
    handleAddForm(e.target);
  }, true);
  /* Manche Skripte schicken das Formular direkt per form.submit() ab (ohne submit-Event) */
  var origSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (isAddForm(this)) { handleAddForm(this); return; }
    return origSubmit.apply(this, arguments);
  };

  var pending = null;
  function onCartRequest(url, method, ok, internal) {
    if (internal || !ok || !/\/cart\/(add|change|update|clear)/.test(url) || (method || 'GET').toUpperCase() !== 'POST') return;
    var isAdd = /\/cart\/add/.test(url);
    clearTimeout(pending);
    pending = setTimeout(function () { if (isAdd) open(); else if (state.open) refresh(); else getCart().then(emitUpdated).catch(function () {}); }, 120);
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) || (input && input.method) || 'GET';
    var hdrs = (init && init.headers) || {};
    var internal = !!(hdrs['X-SPC'] || (hdrs.get && hdrs.get('X-SPC')));
    return origFetch(input, init).then(function (res) { try { onCartRequest(url, method, res.ok, internal); } catch (e) {} return res; });
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this._spc = { m: m, u: u }; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this; x.addEventListener('load', function () { if (x._spc) onCartRequest(String(x._spc.u), x._spc.m, x.status >= 200 && x.status < 300, false); });
    return xs.apply(this, arguments);
  };

  document.addEventListener('ajaxProduct:added', function () { open(); });
  document.addEventListener('cart:open', function () { open(); });
  document.addEventListener('cart:close', close);
  ['cart:build', 'cart:refresh'].forEach(function (ev) { document.addEventListener(ev, function () { if (state.open) refresh(); }); });

  /* Kompatibilität mit bestehenden Skripten (mw-product-upsell u. a.) */
  window.theme = window.theme || {};
  window.theme.cart = window.theme.cart || {};
  window.theme.cart.openCart = open;
  window.spCart = { open: open, close: close, refresh: refresh };

  /* Erstes Laden: Geschenk-Status abgleichen, ohne Drawer zu öffnen */
  if (!isCartPage) getCart().then(syncGift).then(function (c) { render(c); }).catch(function () {});
})();
